import { useTranslation } from 'react-i18next';
import { Input, InputProps } from '../Input';
import { withTranslation } from '../../locales/hoc';

const LastNameFieldComponent = (inputProps: InputProps) => {
	const { t } = useTranslation();

	return (
		<Input
			textContentType="familyName"
			placeholder={t('common.last-name')}
			label={t('common.last-name')}
			{...inputProps}
		/>
	);
};

export const LastNameField = withTranslation(LastNameFieldComponent);
